import React from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "../../../actions/actionCreators";
import withModal from "../withModal";
import MaterialModal from "../MaterialModal";
import FieldLabelsMain from "./FieldLabelsMain";

// Types and Interfaces
type IProps = {
    isOpen: boolean;
};

const FieldLabelsModal: React.FC<IProps> = ({ isOpen }: IProps) => {
    const dispatch = useDispatch();
    const hide = () => dispatch(hideModal("EDIT_FIELD_LABELS"));

    return (
        <MaterialModal
            id="variable-admin-modal"
            isOpen={isOpen}
            onClose={hide}
            title="Edit Field Labels"
            onPrimaryButtonRequest={hide}
            showPrimaryButton={false}
            cancelButtonText="Close"
        >
            <FieldLabelsMain />
        </MaterialModal>
    );
};

export default withModal(FieldLabelsModal, "EDIT_FIELD_LABELS");
